import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import App from './App';
import store from './store/index';

// 👇 Create a root using the new API
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <Router>
                <Routes>
                    <Route path="/" element={<Navigate to="/default.vcf" replace />} />
                    <Route path="/:filename" element={<App />} />
                </Routes>
            </Router>
        </Provider>
    </React.StrictMode>
);
